<template>
    <div class="container franvaro">
        <div class="fk-content-wide" style="border-radius:6px;font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;font-weight:600;user-select: none;">

            <div v-if="!isLoading" class="info_area">

                <div style="font-size:42px;margin-bottom:30px;">

                    <div class="rubrik">Karttest</div>

                    <div style="display:flex;flex-direction:row;justify-content:center;margin-top:20px;">
                        <div id="chart_1" style="background:white;width:1000px;height:500px;">&nbsp;</div>
                        <!-- Här ligger diagrammet -->
                    </div>

                    <div style="display:flex;flex-direction:row;justify-content:center;">
                        <div class="btn-container">
                            <input type="radio" name="value_period" @click="display_chart()" id="Feb2020" checked hidden />
                            <label class="btn-label" for="Feb2020">Februari 2020</label>

                            <input type="radio" name="value_period" @click="display_chart()" id="Feb2022" hidden />
                            <label class="btn-label" for="Feb2022">Februari 2022</label>
                        </div>
                    </div>

                </div>

            </div>
            <div v-else class="loader"></div>
        </div>
    </div>
</template>
<script>
    import _ from "lodash";
    import Alert from './Alert.vue';
    import global_resources from './global_resources.js';
    import Vue from 'vue';
    import vSelect from 'vue-select';
    Vue.component('v-select', vSelect);
    import 'vue-select/dist/vue-select.css';
    import Multiselect from 'vue-multiselect';

    import * as echarts from 'echarts';


    // register globally
    Vue.component('multiselect', Multiselect)
    export default {
        data() {
            return {};
        },
        created: function () {
            this.isLoading = false;      
        },
        computed: {
        },
        watch: {
        },
        mounted: function () {

            console.log("> mounted");

            this.display_chart();
        },
        components: {
            Alert
        },
        methods: {

            display_chart: function () {

                console.log("### display_chart");

                //Peka ut vilken <div> som diagrammet ska ligga i
                var chartDom = document.getElementById('chart_1');
                var myChart = echarts.init(chartDom);
                var option;

                if ($("#Feb2022").is(':checked')) {
                    var data = [
                        { name: 'Falköpings kommun', value: 3265 },
                        { name: 'Götene kommun', value: 1826 },
                        { name: 'Skara kommun', value: 2057 },
                        { name: 'Tidaholms kommun', value: 1473 }
                        ];
                    var series_name = 'Antal VAB 2022-02'
                } else {
                    var data = [
                        { name: 'Falköpings kommun', value: 2640 },
                        { name: 'Götene kommun', value: 1212 },
                        { name: 'Skara kommun', value: 1325 },
                        { name: 'Tidaholms kommun', value: 974 }
                        ];
                    var series_name = 'Antal VAB 2020-02'
                }

                //Visa laddningsanimation medan data laddas
                myChart.showLoading();

                //Läs in kartdata från en lokal textfil
                $.get('../static/local_data/USAtest.json', function (vabJson) {
                myChart.hideLoading();
                echarts.registerMap('VAB', vabJson, {
                });
                option = {
                    title: {
                    text: 'Antal personer som vabbade under februari 2020/2022',
                    subtext: 'Data från Försäkringskassan',
                    left: 'right'
                    },
                    tooltip: {
                    trigger: 'item',
                    showDelay: 0,
                    transitionDuration: 0.2
                    },
                    visualMap: {
                    left: 'right',
                    min: 500,
                    max: 5000,
                    inRange: {
                        color: [
                        '#313695',
                        '#4575b4',
                        '#74add1',
                        '#abd9e9',
                        '#e0f3f8',
                        '#ffffbf',
                        '#fee090',
                        '#fdae61',
                        '#f46d43',
                        '#d73027',
                        '#a50026'
                        ]
                    },
                    text: ['Hög', 'Låg'],
                    calculable: true
                    },
                    toolbox: {
                    show: true,
                    left: 'left',
                    top: 'top',
                    feature: {
                        dataView: { readOnly: false },
                        restore: {},
                        saveAsImage: {}
                    }
                    },
                    series: [
                    {
                        name: series_name,
                        type: 'map',
                        //Tillåt zoomning/panorering av kartan
                        roam: true,
                        map: 'VAB',
                        emphasis: {
                        label: {
                            show: true
                        }
                        },
                        // För tillfället hårdkodad vab-data
                        data: data
                    }
                    ]
                };
                myChart.setOption(option);
                });

                option && myChart.setOption(option);

            },


            roundMe: function (nFigs, num) {
                return +(Math.round(num + "e+" + nFigs) + "e-" + nFigs);
            },

            getDatesInRange: function (startDate, endDate) {
                const date = new Date(startDate.getTime());
                const dates = [];
                while (date <= endDate) {
                    dates.push(new Date(date));
                    date.setDate(date.getDate() + parseInt(this.interval));
                }
                return dates;
            },

        },
    };
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

    .btn-container {
        width: 300px;
    }

    #Feb2020 + .btn-label:before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 100%;
        z-index: -1;
        background-color: rgba(255, 106, 0, 0.8);
        transition: all 0.3s ease;
        border-radius: 15px;
    }

    #Feb2020:checked + .btn-label:before {
        left: 0;
    }

    #Feb2020:checked + .btn-label,
    #Feb2022:checked + .btn-label {
        color: #000;
    }

</style>



// WEBPACK FOOTER //
// src/Forsakringskassan_VAB.vue